import {GlobalVariables} from "../GlobalVariables";

export default class BlockDirectory {
    static init() {
        let blocks = document.querySelectorAll('.block-directory');

        blocks.forEach(block => {
            this.initSlider(block);
            this.initModal(block);
        });
    }

    static initSlider(block) {
        const swiperPhotosContainer = block.querySelector('.directory-slider-photos .swiper');
        const swiperTextContainer = block.querySelector('.directory-slider-text .swiper');
        // const navigation = block.querySelector('.swiper-navigation');
        const swiperPhotos = new Swiper(swiperPhotosContainer, {
            slidesPerView: "1",
            grabCursor: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
        });

        const swiperText = new Swiper(swiperTextContainer, {
            slidesPerView: "1",
            grabCursor: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            autoHeight: true,
        });

        // 🔁 Lier les deux sliders ensemble
        swiperPhotos.controller.control = swiperText;
        swiperText.controller.control = swiperPhotos;

        block._swiperPhotos = swiperPhotos;
        block._swiperText = swiperText;

        const navContainer = block.querySelector('.directory-slider-nav');
        const prevInfo = navContainer?.querySelector('.prev-slide-info');
        const nextInfo = navContainer?.querySelector('.next-slide-info');
        const prevBtn = navContainer?.querySelector('.prev-btn');
        const nextBtn = navContainer?.querySelector('.next-btn');


        const updateNavInfo = () => {
            const activeIndex = swiperText.activeIndex;
            const slides = swiperText.slides;

            const prevSlide = slides[activeIndex - 1];
            const nextSlide = slides[activeIndex + 1];

            const getDataFromSlide = (slide) => {
                if (!slide) return { name: '', job: '', brand: '' };
                return {
                    name: slide.dataset.name || '',
                    job: slide.dataset.job || '',
                    brand: slide.dataset.brand || ''
                };
            };

            const prevData = getDataFromSlide(prevSlide);
            const nextData = getDataFromSlide(nextSlide);

            if (prevInfo) {
                prevInfo.innerHTML = `
            <div class="nav-name">${prevData.name}</div>
            <div class="nav-job">${prevData.job}</div>
            <div class="nav-brand">${prevData.brand}</div>
        `;
            }

            if (nextInfo) {
                nextInfo.innerHTML = `
            <div class="nav-name">${nextData.name}</div>
            <div class="nav-job">${nextData.job}</div>
            <div class="nav-brand">${nextData.brand}</div>
        `;
            }

            // ✅ Désactiver les boutons si pas de slide prev/next
            if (prevBtn) prevBtn.disabled = !prevSlide;
            if (nextBtn) nextBtn.disabled = !nextSlide;
        };

        swiperText.on('slideChange', updateNavInfo);

        prevBtn?.addEventListener('click', () => swiperText.slidePrev());
        nextBtn?.addEventListener('click', () => swiperText.slideNext());

        updateNavInfo();
    }

    static initModal(block) {
        const directorySlider = block.querySelector(".directory-slider");
        const close = directorySlider.querySelector(".close");
        const cards = block.querySelectorAll(".card-member");

        const swiperPhotos = block._swiperPhotos;
        const swiperText = block._swiperText;

        cards.forEach(card => {
            card.addEventListener("click", () => {
                const index = parseInt(card.dataset.sliderIndex, 10) - 1;

                directorySlider.classList.add("active");
                GlobalVariables.lenis?.stop();

                if (swiperPhotos && swiperText) {
                    swiperPhotos.slideTo(index);
                    swiperText.slideTo(index);
                }
            });
        });

        close.addEventListener("click", () => {
            directorySlider.classList.remove("active");
            GlobalVariables.lenis?.start();
        });
    }
}
